import React from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { authAPI, setAuthToken } from '../services/api';

const Login = () => {
  const { register, handleSubmit, formState: { errors, isSubmitting } } = useForm();

  const onSubmit = async ({ email, password }) => {
    try {
      const res = await authAPI.login(email, password);
      const { token, user } = res.data || {};
      if (!token) throw new Error('No token');
      try {
        localStorage.setItem('authToken', token);
        localStorage.setItem('authUser', JSON.stringify(user));
      } catch {}
      setAuthToken(token);
      toast.success('Logged in');
      window.location.href = '/';
    } catch (e) {
      toast.error('Invalid credentials');
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="card p-6 w-full max-w-sm">
        <h1 className="text-xl font-semibold text-gray-900 mb-4">Sign in</h1>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-3">
          <div>
            <label className="label">Email</label>
            <input type="email" className="input" placeholder="you@example.com" {...register('email', { required: 'Email is required' })} />
            {errors.email && <p className="text-red-600 text-sm mt-1">{errors.email.message}</p>}
          </div>
          <div>
            <label className="label">Password</label>
            <input type="password" className="input" placeholder="••••••••" {...register('password', { required: 'Password is required' })} />
            {errors.password && <p className="text-red-600 text-sm mt-1">{errors.password.message}</p>}
          </div>
          <button type="submit" className="btn btn-primary w-full" disabled={isSubmitting}>
            {isSubmitting ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;